import React, { Component } from 'react';
import { CollectionsPickerMobileContainer, CollectionsPickerMobileTitle } from './CollectionsPickerMobile.styled';

import config from './../../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { COLOR } from '../../../theme/constants';

export default class CollectionsPickerMobile extends Component<
   {
      title: string;
      hidden: boolean;
   },
   {}
> {
   public render() {
      const { title, hidden } = this.props;
      const formattedAnalytics = hidden ? 'Close' : 'Open';

      return (
         <CollectionsPickerMobileContainer
            data-analytics={`CollectionPicker-${formattedAnalytics}`}
            flexDirection='row'
            justifyContent='space-between'
            // onClick={onClick}
         >
            <CollectionsPickerMobileTitle>{title}</CollectionsPickerMobileTitle>
            <FontAwesomeIcon icon={!hidden ? faChevronUp : faChevronDown} width={15} color={COLOR.BLUE} />
         </CollectionsPickerMobileContainer>
      );
   }
}
